import _classCallCheck from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/inherits";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { EventType, PlatformEvent } from "./PlatformEvent";
export var AudioSourceEvent = /*#__PURE__*/function (_PlatformEvent) {
  _inherits(AudioSourceEvent, _PlatformEvent);

  function AudioSourceEvent(eventName, audioSourceId) {
    var _this;

    var eventType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EventType.Info;

    _classCallCheck(this, AudioSourceEvent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AudioSourceEvent).call(this, eventName, eventType));
    _this.privAudioSourceId = audioSourceId;
    return _this;
  }

  _createClass(AudioSourceEvent, [{
    key: "audioSourceId",
    get: function get() {
      return this.privAudioSourceId;
    }
  }]);

  return AudioSourceEvent;
}(PlatformEvent); // tslint:disable-next-line:max-classes-per-file

export var AudioSourceInitializingEvent = /*#__PURE__*/function (_AudioSourceEvent) {
  _inherits(AudioSourceInitializingEvent, _AudioSourceEvent);

  function AudioSourceInitializingEvent(audioSourceId) {
    _classCallCheck(this, AudioSourceInitializingEvent);

    return _possibleConstructorReturn(this, _getPrototypeOf(AudioSourceInitializingEvent).call(this, "AudioSourceInitializingEvent", audioSourceId));
  }

  return AudioSourceInitializingEvent;
}(AudioSourceEvent); // tslint:disable-next-line:max-classes-per-file

export var AudioSourceReadyEvent = /*#__PURE__*/function (_AudioSourceEvent2) {
  _inherits(AudioSourceReadyEvent, _AudioSourceEvent2);

  function AudioSourceReadyEvent(audioSourceId) {
    _classCallCheck(this, AudioSourceReadyEvent);

    return _possibleConstructorReturn(this, _getPrototypeOf(AudioSourceReadyEvent).call(this, "AudioSourceReadyEvent", audioSourceId));
  }

  return AudioSourceReadyEvent;
}(AudioSourceEvent); // tslint:disable-next-line:max-classes-per-file

export var AudioSourceOffEvent = /*#__PURE__*/function (_AudioSourceEvent3) {
  _inherits(AudioSourceOffEvent, _AudioSourceEvent3);

  function AudioSourceOffEvent(audioSourceId) {
    _classCallCheck(this, AudioSourceOffEvent);

    return _possibleConstructorReturn(this, _getPrototypeOf(AudioSourceOffEvent).call(this, "AudioSourceOffEvent", audioSourceId));
  }

  return AudioSourceOffEvent;
}(AudioSourceEvent); // tslint:disable-next-line:max-classes-per-file

export var AudioSourceErrorEvent = /*#__PURE__*/function (_AudioSourceEvent4) {
  _inherits(AudioSourceErrorEvent, _AudioSourceEvent4);

  function AudioSourceErrorEvent(audioSourceId, error) {
    var _this2;

    _classCallCheck(this, AudioSourceErrorEvent);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(AudioSourceErrorEvent).call(this, "AudioSourceErrorEvent", audioSourceId, EventType.Error));
    _this2.privError = error;
    return _this2;
  }

  _createClass(AudioSourceErrorEvent, [{
    key: "error",
    get: function get() {
      return this.privError;
    }
  }]);

  return AudioSourceErrorEvent;
}(AudioSourceEvent); // tslint:disable-next-line:max-classes-per-file

export var AudioStreamNodeEvent = /*#__PURE__*/function (_AudioSourceEvent5) {
  _inherits(AudioStreamNodeEvent, _AudioSourceEvent5);

  function AudioStreamNodeEvent(eventName, audioSourceId, audioNodeId) {
    var _this3;

    _classCallCheck(this, AudioStreamNodeEvent);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(AudioStreamNodeEvent).call(this, eventName, audioSourceId));
    _this3.privAudioNodeId = audioNodeId;
    return _this3;
  }

  _createClass(AudioStreamNodeEvent, [{
    key: "audioNodeId",
    get: function get() {
      return this.privAudioNodeId;
    }
  }]);

  return AudioStreamNodeEvent;
}(AudioSourceEvent); // tslint:disable-next-line:max-classes-per-file

export var AudioStreamNodeAttachingEvent = /*#__PURE__*/function (_AudioStreamNodeEvent) {
  _inherits(AudioStreamNodeAttachingEvent, _AudioStreamNodeEvent);

  function AudioStreamNodeAttachingEvent(audioSourceId, audioNodeId) {
    _classCallCheck(this, AudioStreamNodeAttachingEvent);

    return _possibleConstructorReturn(this, _getPrototypeOf(AudioStreamNodeAttachingEvent).call(this, "AudioStreamNodeAttachingEvent", audioSourceId, audioNodeId));
  }

  return AudioStreamNodeAttachingEvent;
}(AudioStreamNodeEvent); // tslint:disable-next-line:max-classes-per-file

export var AudioStreamNodeAttachedEvent = /*#__PURE__*/function (_AudioStreamNodeEvent2) {
  _inherits(AudioStreamNodeAttachedEvent, _AudioStreamNodeEvent2);

  function AudioStreamNodeAttachedEvent(audioSourceId, audioNodeId) {
    _classCallCheck(this, AudioStreamNodeAttachedEvent);

    return _possibleConstructorReturn(this, _getPrototypeOf(AudioStreamNodeAttachedEvent).call(this, "AudioStreamNodeAttachedEvent", audioSourceId, audioNodeId));
  }

  return AudioStreamNodeAttachedEvent;
}(AudioStreamNodeEvent); // tslint:disable-next-line:max-classes-per-file

export var AudioStreamNodeDetachedEvent = /*#__PURE__*/function (_AudioStreamNodeEvent3) {
  _inherits(AudioStreamNodeDetachedEvent, _AudioStreamNodeEvent3);

  function AudioStreamNodeDetachedEvent(audioSourceId, audioNodeId) {
    _classCallCheck(this, AudioStreamNodeDetachedEvent);

    return _possibleConstructorReturn(this, _getPrototypeOf(AudioStreamNodeDetachedEvent).call(this, "AudioStreamNodeDetachedEvent", audioSourceId, audioNodeId));
  }

  return AudioStreamNodeDetachedEvent;
}(AudioStreamNodeEvent); // tslint:disable-next-line:max-classes-per-file

export var AudioStreamNodeErrorEvent = /*#__PURE__*/function (_AudioStreamNodeEvent4) {
  _inherits(AudioStreamNodeErrorEvent, _AudioStreamNodeEvent4);

  function AudioStreamNodeErrorEvent(audioSourceId, audioNodeId, error) {
    var _this4;

    _classCallCheck(this, AudioStreamNodeErrorEvent);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(AudioStreamNodeErrorEvent).call(this, "AudioStreamNodeErrorEvent", audioSourceId, audioNodeId));
    _this4.privError = error;
    return _this4;
  }

  _createClass(AudioStreamNodeErrorEvent, [{
    key: "error",
    get: function get() {
      return this.privError;
    }
  }]);

  return AudioStreamNodeErrorEvent;
}(AudioStreamNodeEvent);